import { Pipe, PipeTransform } from '@angular/core';
import { isValid, parse } from 'date-fns';
import { de } from 'date-fns/locale';

@Pipe({
  name: 'underageBirthdateError',
  standalone: true,
})
export class UnderageBirthdateErrorPipe implements PipeTransform {
  public transform(day: string, month: string, year: string): string {
    const date = parse(`${day}.${month}.${year}`, 'P', new Date(), { locale: de });
    if (!isValid(date)) {
      return 'invalid';
    }

    const today = new Date();

    // min age is 1 month, inclusive
    const youngestDate = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());
    // max age is 16 years, exclusive
    const oldestDate = new Date(today.getFullYear() - 16, today.getMonth(), today.getDate());

    if (date > youngestDate) {
      return 'too-young';
    }

    if (date <= oldestDate) {
      return 'too-old';
    }

    return null;
  }
}
